import React from "react";
import { Alert, Button, Space, Typography } from "antd";

interface Props {
  resource: { data?: unknown; loading: boolean; error: unknown; refresh: () => Promise<unknown> };
  label: string;
  errorMessage?: string;
}

export default function BusinessResourceNotice({ resource, label, errorMessage }: Props) {
  if (!resource.error && !resource.loading) return null;
  return <Alert style={{ marginBottom: 12 }} showIcon
    type={resource.error ? "warning" : "info"}
    message={resource.error ? errorMessage || `Impossible d’actualiser ${label}.`
      : `Actualisation de ${label}…`}
    description={<Space direction="vertical">
      <Typography.Text>{Boolean(resource.data)
        ? "Les dernières données disponibles et votre saisie sont conservées."
        : "Les données doivent être chargées pour continuer."}</Typography.Text>
      {Boolean(resource.error) && <Button size="small" loading={resource.loading}
        onClick={() => { void resource.refresh().catch(() => {}); }}>Réessayer</Button>}
    </Space>} />;
}
